// @em/ui — Google Maps key injection.
//
// The Maps loader needs an API key, but a package can't read the consumer's env.
// Each app injects it once at startup via `configureGoogleMaps({ apiKey })`, and
// GoogleMapsContext reads it from here. Same injection pattern as configureIcons /
// configureApiService.
export interface GoogleMapsConfig {
  apiKey: string;
}

let config: GoogleMapsConfig = { apiKey: "" };

/** Register the Google Maps API key once at app startup. */
export const configureGoogleMaps = (cfg: GoogleMapsConfig): void => {
  config = { ...config, ...cfg };
};

export const getGoogleMapsConfig = (): GoogleMapsConfig => config;
